"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

var _createButton = _interopRequireDefault(require("./create-button"));

var _conf = require("../../conf");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var endpoints = {
  brunch: 'brunchApiUrlTemplate',
  schub: 'schubApiUrlTemplate',
  vomhof: 'vomhofFromFarmApiUrl',
  lockpfosten: 'lockpfostenApiUrlTemplate',
  stallvisite: 'stallvisiteFromFarmApiUrl',
  toh: 'tohFromFarmApiUrl',
  lgw: 'lgwFromFarmApiUrl'
};

var ProjectDetailLink = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectDetailLink, _React$Component);

  function ProjectDetailLink(props) {
    var _this;

    _classCallCheck(this, ProjectDetailLink);

    _this = _possibleConstructorReturn(this, (ProjectDetailLink.__proto__ || Object.getPrototypeOf(ProjectDetailLink)).call(this, props));
    _this.state = {
      creation: {
        success: null,
        message: ''
      }
    };
    _this.createProject = _this.createProject.bind(_assertThisInitialized(_this));
    _this.getReleaseLink = _this.getReleaseLink.bind(_assertThisInitialized(_this));
    _this.getCreateButton = _this.getCreateButton.bind(_assertThisInitialized(_this));
    _this.messages = _this.messages.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProjectDetailLink, [{
    key: "render",
    value: function render() {
      var create = this.props.create;

      if (create === true) {
        return this.getCreateButton();
      }

      return this.getReleaseLink();
    }
  }, {
    key: "getReleaseLink",
    value: function getReleaseLink() {
      var _this$props = this.props,
          projectType = _this$props.projectType,
          farmId = _this$props.farmId;
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: "/".concat(projectType, "-release/").concat(farmId)
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
  }, {
    key: "getCreateButton",
    value: function getCreateButton() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_createButton.default, {
        t: t,
        messages: this.messages,
        createProject: this.createProject,
        success: this.state.creation.success
      }, /*#__PURE__*/_react.default.createElement("span", null, t('hallo')));
    }
  }, {
    key: "createProject",
    value: function createProject() {
      var _this2 = this;

      var _this$props2 = this.props,
          projectType = _this$props2.projectType,
          farmId = _this$props2.farmId,
          language = _this$props2.language,
          history = _this$props2.history,
          onError = _this$props2.onError;
      var endpoint = _conf.api[endpoints[projectType]];
      fetch(endpoint(language, farmId), {
        credentials: 'include',
        method: 'POST'
      }).then(function (response) {
        var creation = _this2.state.creation;

        if (response && response.status !== 200) {
          creation.success = false;
          creation.message = 'Could not create Project';

          if (response.status === 403) {
            creation.message = 'You do not have permissions to create Project';
          }

          _this2.setState({
            creation: creation
          });

          setTimeout(function () {
            _this2.setState(function (prev) {
              prev.creation = {
                success: null,
                message: ''
              };
              return prev;
            });
          }, 2000);
          void 0;
        } else {
          _this2.setState({
            creation: {
              success: true,
              message: 'Project created successfully'
            }
          });

          setTimeout(function () {
            history.push("/".concat(projectType, "-release/").concat(farmId));
          }, 2000);
        }
      }).catch(function (err) {
        if (onError) {
          return onError(err);
        }

        void 0;
      });
    }
  }, {
    key: "messages",
    value: function messages() {
      var t = this.props.t;

      if (this.state.creation.success === false) {
        return /*#__PURE__*/_react.default.createElement("div", {
          "data-abide-error": true,
          role: "alert",
          className: "alert center"
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "fi-warning"
        }), t(this.state.creation.message));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "success center",
        "data-closable": "slide-out-right"
      }, t(this.state.creation.message));
    }
  }]);

  return ProjectDetailLink;
}(_react.default.Component);

ProjectDetailLink.propTypes = {
  history: _propTypes.default.object.isRequired,
  farmId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  projectType: _propTypes.default.string.isRequired,
  create: _propTypes.default.bool.isRequired,
  t: _propTypes.default.func.isRequired,
  language: _propTypes.default.string.isRequired,
  onError: _propTypes.default.func
};
module.exports = (0, _translate.default)(ProjectDetailLink);


//////////////////
// WEBPACK FOOTER
// ./client/components/project-detail-link/index.js
// module id = 703
// module chunks = 0